import { DeliveryType } from 'src/api/@generated/backend-api';

export interface OrderState {
  lastVisitedProductDetailsPage?: ProductDetailsPage;
  reachedStep: OrderStep;
  selectedDeliveryType: DeliveryType;
}

export enum OrderStep {
  CHOOSE_ACCOUNT = 'CHOOSE_ACCOUNT',
  CHOOSE_SERVICE_LOCATION = 'CHOOSE_SERVICE_LOCATION',
  PRODUCT_SELECT = 'PRODUCT_SELECT',
  UPGRADE_DECODER = 'UPGRADE_DECODER',
  PURCHASE_DECODER = 'PURCHASE_DECODER',
  SUMMARY = 'SUMMARY',
  SUCCESS = 'SUCCESS',
}

export type ProductDetailsPage = Extract<OrderStep, OrderStep.PURCHASE_DECODER | OrderStep.UPGRADE_DECODER>;
